

















import Vue from 'vue'
import * as qs from 'qs'

export default Vue.extend({
  name: 'EmailSetting',
  data() {
    return {
      email: this.$route.params.email || sessionStorage.getItem('email') || '',
      isLoading: false
    }
  },
  computed: {
    mailto(): string {
      return `mailto:regist_email@aizuchat.com?subject=${encodeURIComponent(
        this.$route.params.pin
      )}`
    }
  },
  created() {
    if (this.$route.params.resubmit === 'true') {
      this.isLoading = true
      this.registMailAddress()
    }
  },
  methods: {
    /**
     * メアド登録
     */
    async registMailAddress(this: any) {
      try {
        const res = await this.$http.post(
          '/notice_setting/',
          qs.stringify({
            page: 'set_email',
            email: this.email
          })
        )
        if (res.data.error) {
          throw new Error(res.data.error)
        }
        sessionStorage.setItem('email', this.email)
        this.$router.push('/notification/setting/email/auth')
      } catch (err) {
        this.$_alert('メールアドレスの仮登録失敗')
        if (this.isLoading) {
          this.isLoading = false
        }
      }
    }
  }
})
